(function (){
    var links = document.links;
    for (var i = 0, linksLength = links.length; i < linksLength; i++) {
        if (window.location.hostname !== links[i].hostname && links[i].hostname.length > 0 || links[i].pathname.indexOf(".") > 0) {
            links[i].target = "_blank";
        }
    } 

})(document);